import Reveal from "@/components/base/Reveal";

export interface ProcessStep {
  title: string;
  description: string;
  icon?: string;
}

interface ProcessStepsProps {
  steps: ProcessStep[];
  tone?: "light" | "dark";
}

export default function ProcessSteps({ steps, tone = "light" }: ProcessStepsProps) {
  const isDark = tone === "dark";

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {steps.map((step, index) => (
        <Reveal key={step.title} delay={index * 70} className="h-full">
          <article
            className={`relative flex h-full flex-col rounded-xl border p-6 ${
              isDark
                ? "border-background-50/10 bg-background-50/5"
                : "border-background-200 bg-background-50"
            }`}
          >
            <div className="flex items-center justify-between">
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                  isDark ? "bg-accent-500/15 text-accent-300" : "bg-accent-100/70 text-accent-700"
                }`}
              >
                <i className={`${step.icon ?? "ri-check-line"} text-xl`} aria-hidden="true"></i>
              </span>
              <span
                className={`font-heading text-3xl font-bold ${
                  isDark ? "text-background-50/20" : "text-foreground-950/10"
                }`}
              >
                {String(index + 1).padStart(2, "0")}
              </span>
            </div>
            <h3
              className={`mt-4 font-heading text-base font-semibold ${
                isDark ? "text-background-50" : "text-foreground-950"
              }`}
            >
              {step.title}
            </h3>
            <p
              className={`mt-2 text-sm leading-relaxed ${
                isDark ? "text-background-300" : "text-foreground-600"
              }`}
            >
              {step.description}
            </p>
          </article>
        </Reveal>
      ))}
    </div>
  );
}